import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from  "@angular/common/http";
import { constVariables } from "../constants/ConstantPath";

@Injectable({
  providedIn: 'root'
})
export class RoomSearchService {

  
  constructor(private http: HttpClient) { }
  getSearchResults(data) {
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/Searchresults/get_search_results_ota";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}
	addToCart(data){
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/cart/add_to_cart";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}
}
